import get from 'lodash/get';

export const validateVersionLabel = (record, label) => {
  const versions = get(record, 'versions', []);
  //get all version labels
  const versionLabels = versions.map((version) => get(version, 'label', ''));
  if (versionLabels.includes(label)) {
    return false;
  }
  return true;
};

export const incrementVersionNumber = (label) => {
  const str = String(label);

  // detect decimal places
  const decimalPart = get(str.split('.'), '1');
  const precision = decimalPart ? decimalPart.length : 0;

  const currentVersion = Number(str);

  if (Number.isNaN(currentVersion)) {
    return str;
  }

  const incremented = currentVersion + 1;

  // apply same precision
  const newVersionLabel =
    precision > 0 ? incremented.toFixed(precision) : String(incremented);
  return newVersionLabel;
};

export const getLatestVersion = (versions) => {
  //get version with the highest id
  const latestVersion = versions.reduce((prev, current) => {
    if (!prev) return current;
    return prev.id > current.id ? prev : current;
  }, null);
  return latestVersion;
};

export const checkIfRuleSatisfied = (stages) => {
  return stages.every(stage => {
    const assignees = get(stage, 'assignees', []);
    const assigneeTypes = assignees.map(assignee => assignee.type);

    if (assignees.length < 1) {
      return false;
    }
    if (assignees.length < stage.min_assignee_count && assigneeTypes.includes('team')) {
      return true;
    }

    if (assignees.length < stage.min_assignee_count) {
      return false;
    }
    return true;
  });
};